import { SkeletonChild, SkeletonParent } from '@/components/ui/Skeleton/skeleton';

const DailyBonusSkeleton = () => {
  return (
    <section className="relative md:-mx-2 overflow-hidden lg:mb-3.5 max-md:mt-4 rounded-2xl">
      <SkeletonParent className="h-60 md:h-49 w-full rounded-2xl">
        <div className="relative z-1 h-full flex flex-col p-4 md:px-2 md:py-3">
          <div className="flex items-center justify-between mb-4 md:mb-3">
            <SkeletonChild className="h-5 w-32.5 rounded-full" />
          </div>

          <div className="grid grid-cols-5 gap-x-1.5 gap-y-2 md:gap-y-2">
            {Array.from({ length: 10 }).map((_, index) => (
              <SkeletonChild key={index} className="h-16.5 md:h-13 rounded-[0.5rem]" />
            ))}
          </div>

          <div className="flex justify-center mt-4 md:mt-3">
            <SkeletonChild className="h-4 w-60.5 lg:w-57.5 rounded-lg" />
          </div>
        </div>
      </SkeletonParent>
    </section>
  );
};

export default DailyBonusSkeleton;
